<template>
  <v-menu
    offsetY
    max-height="500">
    <template v-slot:activator="{ on }">
      <v-list
        :disabled="isLoading"
        class="pa-0"
        color="transparent"
        dense>
        <v-skeleton-loader
          v-if="isLoading"
          class="mx-auto"
          max-height="50px"
          type="list-item-avatar"
        />
        <v-list-item
          v-else
          v-on="on">
          <v-list-item-icon class="mr-1">
            <v-avatar
              color="primary"
              size="28"
            >
              <span
                class="white--text">
                {{ activeRestaurant.name | initial }}
              </span>
            </v-avatar>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              <div>
                <span class="caption grey--text">
                  Restaurant:
                </span>
                <div class="d-flex justify-between align-center">
                  <div class="restaurant-name">
                    {{ activeRestaurant.name }}
                  </div>
                  <v-icon color="primary">
                    mdi-menu-down
                  </v-icon>
                </div>
              </div>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </template>
    <v-card>
      <v-list flat rounded>
        <v-list-item
          v-for="(restaurant, index) in allRestaurants"
          :key="`restaurant-${index}`"
          @click="selectRestaurant(restaurant)">
          <div :class="restaurant.name === activeRestaurant.name ? 'primary--text' : ''">
            {{ restaurant.name }}
          </div>
        </v-list-item>
        <v-list-item v-if="['manager'].includes($is())">
          <NewRestaurant />
        </v-list-item>
      </v-list>
    </v-card>
  </v-menu>
</template>

<script>
import NewRestaurant from '@/components/modals/NewRestaurant'
import moment from 'moment'

export default {
  name: 'RestaurantSelector',
  components: {
    NewRestaurant
  },
  computed: {
    allRestaurants () {
      return this.$store.state.login.restaurants.data || []
    },
    activeRestaurant () {
      return this.$store.state.currentRestaurant.data || {}
    },
    activeArea () {
      return this.$store.state.area || {}
    },
    isLoading () {
      return this.$store.state.isLoading
    },
    areas () {
      return this.$store.state.currentRestaurant.areas.data
    },
    allowedAreas () {
      return this.$store.state.login.permissions['areas-allowed']
    }
  },
  methods: {
    async selectRestaurant (restaurant) {
      this.$store.commit('changeLoading', true)
      const role = this.$is()
      await this.$store.dispatch('currentRestaurant/select', restaurant)
      const areas = this.areas.filter(x => this.allowedAreas.includes(x._id))
      await this.$store.commit('setArea', areas[0])
      await this.updateLastLogin({ restaurant: restaurant._id })

      this.$store.commit('entities/recipes/search', '')
      this.$store.commit('entities/recipes/setPage', 1)
      if (role !== restaurant.role) {
        const urls = {
          manager: 'Recipes',
          stockmanager: 'CaptureInventory',
          chef: 'Recipes',
          buyer: 'Dishes',
          sales: 'Sales'
        }
        this.$router.push({ name: urls[this.$is()] })
      }
      this.$store.commit('changeLoading', false)
    },
    async updateLastLogin (params) {
      await this.$api.post(`/v1/restaurants/${params.restaurant}`, { lastLogin: moment().format('YYYY-MM-DD HH:mm:ss') })
    }
  }
}
</script>

<style lang="scss" scoped>
.restaurant-name {
  width: calc(100% - 24px);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
